export enum MenuDisplayLayoutEnum {
  LIST = "LIST",
  GRID = "GRID",
}
